import { RotatedTitle } from '../../../../components/rotated-title/rotated-title'
import Accumulation from '../../components/calculation-form/components/form-items/accumulation'
import { onAnyStandardCell } from '../../helpers/helpers'
import type { CalculationColumn } from '../../types/column-types'

export const accumulationColumn: CalculationColumn = {
    dataIndex: 'accumulation',
    title: <RotatedTitle>Сборка</RotatedTitle>,
    width: 30,
    editable: true,
    FormItem: <Accumulation />,
    onCell: onAnyStandardCell,
}
